
import { useLessonCompletion } from '../level/useLessonCompletion';

// Re-export the completeLessonAndAwardXP function from the new module
const { completeLessonAndAwardXP: completeLessonFn } = useLessonCompletion();
export const completeLessonAndAwardXP = completeLessonFn;
